import ArcLoading from "components/ArcLoading";

/** The signed handoff's wait before the flow knows where it opens: the
 * loading mark alone, hinting at no station, so whatever comes next is
 * the first thing the family reads. */
export default function ArrivalLoadingScreen() {
  return (
    <main className="flex flex-1 items-center justify-center px-4 py-24">
      <ArcLoading className="h-8 w-[130px] text-soil" />
    </main>
  );
}
